<template>
    <el-dialog
      id="popup_dialog"
      title="Adauga un interval de zile libere"
      :visible.sync="showPopup"
      class="my-dialog-class custom-width"
      :destroy-on-close="true"
  
    >
      <div class="container">
        <el-form
          label-position="top"
          :inline="false"
          :rules="rules"
          label-width="100%"
          :model="selectedObject"
          ref="my-form"
          @submit.prevent="save"
          v-loading="loadingVisible"
        >
          <el-row :gutter="15">
            <el-col :md="8">
              <el-form-item label="Denumire" prop="Denumire">
                <el-input class="full-width" v-model="selectedObject.Denumire" />
              </el-form-item>
            </el-col>
            <el-col :md="8">
              <el-form-item label="Utilizator" prop="IdUtilizator">
                <el-select class="full-width" v-model="selectedObject.IdUtilizator" filterable>
                  <el-option label="Toti" value="-1"></el-option>
                  <el-option
                    v-for="item in Info.utilizatori"
                    :key="'utilizatori' + item.Id"
                    :label="item.Nume"
                    :value="item.Id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :md="8">
              <el-form-item label='Interval' prop="ZileLibere">
                  <el-date-picker
                      v-model="selectedObject.ZileLibere"
                      type="daterange"
                      :picker-options="datePickerOptions"
                      range-separator="-"
                      start-placeholder="Data inceput"
                      end-placeholder="Data sfarsit"
                      format="dd/MM/yyyy"
                      value-format="yyyy-MM-dd"
                      clearable>
                    </el-date-picker>
                </el-form-item>
            </el-col> 
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showPopup = false"> Renunta </el-button>
          <el-button type="primary" @click="save"> Salveaza </el-button>
  
        </span>
      </div>
    </el-dialog>
  </template>
  
  <script>
  import settings from "@/backend/LocalSettings";
  import BasePage from "@/pages/Admin/BasePage";
  
  export default {
    name: "",
    extends: BasePage,
    data() {
      return {
        datePickerOptions: {},
        baseUrl: "",
        showPopup: false,
        selectedObject: {
          Denumire: "",IdUtilizator:'',ZileLibere:[],
        },
        Info: {},
        rules: {
          Denumire: [{ required: true, message: "Campul este obligatoriu" }],
          IdUtilizator: [{ required: true, message: "Campul este obligatoriu" }],
          ZileLibere: [{ required: true, message: "Campul este obligatoriu" }],
        },
      };
    },
    methods: {
      show_me: async function () {
        
        this.selectedObject = { Denumire: "", IdUtilizator:'', ZileLibere:[] };
        this.showPopup = true;
      },
  
  
  
      async get_info() {
        var response = await this.post("utilizatori/get_info_for_dialog_zile_libere");
        this.Info.utilizatori = response.utilizatori;
      },
      async save () {
        await this.$refs["my-form"].validate(async (valid) => {
          if (valid) {
            try {
              await this.post("utilizatori/save_zile_libere_interval", {
                object: this.selectedObject,
              });
              this.$message({type: 'success', message: 'Intervalul de zile libere a fost adaugat cu succes!'});  
              this.selectedObject = { Denumire: "" };
              this.$emit("save");
            } catch (error) {
              this.$message({type: 'error', message: 'A intervenit o problema in adaugarea intervalului de zile libere!'});  
            }finally{
              this.showPopup = false;
            }
            
          }
        });
      },
    },
    mounted: function () {
      this.baseUrl = settings.BASE_URL;
      this.get_info();
      this.datePickerOptions = settings.datePickerOptions;
    },
  };
  </script>
  
  <style lang="less">
  #popup_dialog {
    .full-width {
      width: 100% !important;
    }
  
    .container {
      width: 100% !important;
    }
  
    @media only screen and (max-width: 600px) {
      .el-dialog{
        min-width: 90vw !important;
      }
    }
  }
  </style>